module.exports = __webpack_public_path__ + "static/media/38.057191b0.svg";